import React from "react";
import AceEditor from "react-ace";

import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-xml";

const CodeEditor = ({ value, onChange, language = "javascript", readOnly = false, height = "200px" }) => {
    return (
        <AceEditor
            mode={language}
            theme="tomorrow"
            onChange={onChange}
            value={value || ""}
            name={`code-editor-${Math.random()}`} // Unique name to prevent conflicts
            editorProps={{ $blockScrolling: true }}
            setOptions={{
                useWorker: false, // data URI worker issue sometimes
                showLineNumbers: true,
                tabSize: 2,
            }}
            style={{ width: "100%", height: height, border: "1px solid #ccc", borderRadius: "4px" }}
            readOnly={readOnly}
        />
    );
};

export default CodeEditor;
